// Basic
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';

// Modules
import { MaterialModule } from '@app/material.module';

// Components
import { SelectorAllergensComponent } from './selector-allergens.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    MaterialModule
  ],
  declarations: [SelectorAllergensComponent],
  exports: [SelectorAllergensComponent],
  entryComponents: [SelectorAllergensComponent]
})

export class SelectorAllergensModule { }
